var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Suspense, lazy } from 'react';
import { SamoletLogo, SamoletLogoSmall } from '../../../components/Icon';
import { VisibleBlock } from '../../../components/VisibleBlock';
import { getDataFromLocalStorage } from '../../../helpers/localStorage';
import { LayoutMenu } from '../../Layout/components';
import { Logo } from '../../Layout/components/Logo';
import { useCollapse } from '../../../hooks/collapse';
import { Wrapper, LogoWrapper, ProjectName, MenuList, FooterBlock } from './styled';
import { Trigger } from './components/Trigger';
import { SFB } from './components/SFB';
var SupportButtonBlock = lazy(function () { return import('./components/SupportButtonBlock').then(function (_a) {
    var SupportButtonBlock = _a.SupportButtonBlock;
    return ({ default: SupportButtonBlock });
}); });
var LOCAL_STORAGE_COLLAPSED = 'sider_collapsed';
var Sider = function (_a) {
    var _b = _a.defaultCollapsed, defaultCollapsed = _b === void 0 ? false : _b, _c = _a.menu, menu = _c === void 0 ? [] : _c, projectTitle = _a.projectTitle, logoToRoot = _a.logoToRoot, logoExtra = _a.logoExtra, logoUrl = _a.logoUrl, menuProps = _a.menuProps, onSupport = _a.onSupport, withSupport = _a.withSupport, renderMenuItem = _a.renderMenuItem, props = __rest(_a, ["defaultCollapsed", "menu", "projectTitle", "logoToRoot", "logoExtra", "logoUrl", "menuProps", "onSupport", "withSupport", "renderMenuItem"]);
    var _d = useCollapse(!!getDataFromLocalStorage(LOCAL_STORAGE_COLLAPSED) || defaultCollapsed, LOCAL_STORAGE_COLLAPSED), collapsed = _d.collapsed, onToggle = _d.onToggle;
    var isCollapsed = props.collapsed ? props.collapsed : collapsed;
    return (React.createElement(Wrapper, __assign({ width: 240, theme: 'light', collapsible: true, collapsed: isCollapsed, onCollapse: props.onCollapse ? props.onCollapse : onToggle, trigger: React.createElement(Trigger, { collapsed: isCollapsed }) }, props),
        React.createElement(LogoWrapper, null, !isCollapsed ? (React.createElement(React.Fragment, null,
            React.createElement(Logo, { root: logoToRoot, logoUrl: logoUrl },
                React.createElement(SamoletLogo, null),
                logoExtra),
            projectTitle && React.createElement(ProjectName, null, projectTitle))) : (React.createElement(Logo, { root: logoToRoot, logoUrl: logoUrl },
            React.createElement(SamoletLogoSmall, null)))),
        React.createElement(MenuList, null,
            React.createElement(LayoutMenu, __assign({ menu: menu, renderMenuItem: renderMenuItem, collapsed: isCollapsed }, menuProps))),
        React.createElement(FooterBlock, { collapsed: isCollapsed },
            React.createElement(SFB, { collapsed: isCollapsed }),
            React.createElement(VisibleBlock, { visible: withSupport },
                React.createElement(Suspense, { fallback: null },
                    React.createElement(SupportButtonBlock, { collapsed: isCollapsed, onSupport: onSupport }))))));
};
export default Sider;
//# sourceMappingURL=Sider.js.map